import { useNavigate } from 'react-router-dom';

import { type Partner } from '@/api/routes/partners/partners.api';
import Button from '@/components/Button';
import { IconCircleX } from '@/components/icon/tabler/IconCircleX';
import StatusGate from '@/domain/account-status/components/StatusGate';
import { ONBOARDING_EDIT_URL, SUPPORT_WHATSAPP_URL } from '@/domain/account-status/utils';
import { useTranslate } from '@/state/i18n';

interface Props {
  partner: Partner;
}

/** P06: the team's note comes in full; editing sends the account back to review. */
const StatusRejected = ({ partner }: Props) => {
  const navigate = useNavigate();
  const t = useTranslate('domain.account-status.components.StatusRejected');

  return (
    <StatusGate
      icon={<IconCircleX color="error" sx={{ fontSize: 44 }} />}
      title={t('title')}
      description={t('description')}
      note={partner.reviewNote ? { label: t('noteLabel'), text: partner.reviewNote } : null}
      actions={
        <>
          <Button onClick={() => navigate(ONBOARDING_EDIT_URL)} variant="contained">
            {t('editAndResubmit')}
          </Button>
          <Button
            href={SUPPORT_WHATSAPP_URL}
            target="_blank"
            rel="noopener noreferrer"
            variant="text"
          >
            {t('contact')}
          </Button>
        </>
      }
    />
  );
};

export default StatusRejected;
